module.exports = __webpack_public_path__ + "static/media/Eyewear_onlineServices_EP1_Cover.2cfe41e7.jpg";